import React from "react";
import "./StandardHeader.scss";
import { Layout, theme } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppTitle from "../AppTitle/AppTitle";
import { resetPatientsError } from "../../features/patients/patientsSlice";
import { Register } from "../AppHeader/components";
import useWindowDimensions from "../../hooks/useWindowDimensions";

const { Header } = Layout;

export default function StandardHeader() {
  const { useToken } = theme;
  const { token } = useToken();
  const { error } = useSelector((state) => state?.patients);
  const dispatch = useDispatch();
  const { width, isMobile } = useWindowDimensions();
  const navigate = useNavigate();

  return (
    <Header className="standardHeader-cont">
      <AppTitle
        token={token}
        classNameCont="standardHeader-cont__left__titeWrapper"
        classNameTitle="standardHeader-cont__title"
        onTitleClick={() => {
          if (error) {
            dispatch(resetPatientsError());
          }
          navigate("/");
        }}
      />
      <Register
        token={token}
        isMobile={isMobile}
        width={width}
        is_searched={false}
      />
    </Header>
  );
}
